export default __webpack_public_path__ + "images/security_8a5b4d.svg";